import { useState, useEffect, useRef } from "react";

// import arrowrightcircle from "./assets/images/arrowrightcircle.svg";
// import group2 from "./assets/images/group-2.svg";
import interfaceessentialsend1 from "assets/chatImages/interface-essentialsend1.svg";
import axios from "axios";
import bot from "assets/chatImages/bot.png";
import userProfile from "assets/chatImages/user.png";
// import { dateSVG, trainSVG } from "./helper/svgs";

export default function ChatInterfaceDocuments() {
  const messageEl = useRef(null);

  const [question, setQuestion] = useState();
  const [toggleFilterSection, setToggleFilterSection] = useState(false);
  const [addPrompt, setAddPrompt] = useState("");
  const [chats, setChats] = useState([
    {
      id: 0,
      type: 1, // 0 is question and 1 is answer
      content: "Hi, how can I help you?",
      end: true,
      loading: false,
    },
  ]);

  useEffect(() => {
    if (messageEl) {
      messageEl.current.addEventListener("DOMNodeInserted", (event) => {
        const { currentTarget: target } = event;
        target.scroll({ top: target.scrollHeight, behavior: "smooth" });
      });
    }
  }, []);

  function getHightestID(chats) {
    const highestId = chats.reduce((maxId, item) => {
      return item.id > maxId ? item.id : maxId;
    }, -1);
    return highestId;
  }

  const updateChatById = (id, loading, content) => {
    setChats((prevChats) =>
      prevChats.map((chat) =>
        chat.id === id ? { ...chat, loading, content } : chat
      )
    );
  };

  function getAnswer(content, newID) {
    const newIDAnswer = newID + 1;
    setChats((prevChats) => [
      ...prevChats,
      {
        id: newIDAnswer,
        type: 1,
        content: newIDAnswer,
        end: true,
        loading: true,
      },
    ]);
    const data = {
      query: content,
      source_documents: true,
    };
    axios
      .post("http://127.0.0.1:5110/api/prompt_route", data)
      .then((response) => {
        setAddPrompt("");
        updateChatById(newIDAnswer, false, response.data.Answer);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  function addQuestion(content) {
    const newID = getHightestID(chats) + 1;

    setChats((prevChats) => [
      ...prevChats,
      {
        id: newID,
        type: 0,
        content: content,
        end: true,
        loading: false,
      },
    ]);

    getAnswer(content, newID);
  }

  const filter_fullchat = (chat) => {
    return (
      <div class="chat-message ">
        <div class={`flex items-end ${chat.type === 1 ? "" : "justify-end"}`}>
          <div
            class={`flex cursor-pointer flex-col space-y-2 text-xs max-w-xl mx-2 order-2 ${
              chat.type === 1 ? "items-end" : "items-start"
            }`}
          >
            {chat.loading ? (
              <span
                class={`px-4 py-3 rounded-lg inline-block  ${
                  chat.type === 1
                    ? "bg-[#f4f4f4] text-gray-600 rounded-bl-none"
                    : "bg-[#018FFF] text-white rounded-br-none"
                } `}
              >
                <div class="flex space-x-2">
                  <div class="w-2 h-2 rounded-full bg-gray-500 animate-pulse delay-150"></div>
                  <div class="w-2 h-2 rounded-full bg-gray-500 animate-pulse delay-300"></div>
                  <div class="w-2 h-2 rounded-full bg-gray-500 animate-pulse delay-600"></div>
                </div>
              </span>
            ) : (
              <div>
                <span
                  class={`px-4 py-2 text-base rounded-lg inline-block  ${
                    chat.type === 1
                      ? "bg-[#f4f4f4] text-gray-600 rounded-bl-none"
                      : "bg-[#018FFF] text-white rounded-br-none"
                  } `}
                >
                  {chat.content.split("\n").map((paragraph, index) => (
                    <p
                      key={index}
                      className={`p-4 text-base ${
                        chat.type === 1
                          ? "bg-[#f4f4f4] text-gray-600"
                          : "bg-[#018FFF] text-white"
                      }`}
                    >
                      {paragraph}
                    </p>
                  ))}
                </span>
              </div>
            )}
          </div>
          {chat.end ? (
            <img
              src={chat.type === 1 ? bot : userProfile}
              alt="My profile"
              class={`w-6 h-6 rounded-full  bg-[#f4f4f4] ${
                chat.type === 1 ? "order-1" : "order-2"
              } `}
            />
          ) : (
            <div
              class={`w-6 h-6 rounded-full   ${
                chat.type === 1 ? "order-1" : "order-2"
              } `}
            />
          )}
        </div>
      </div>
    );
  };
  function handleKeyDown(event) {
    if (event.key === "Enter") {
      // Do whatever you need to do when Enter key is pressed
      if (event.target.value !== "") {
        addQuestion(event.target.value);
        setQuestion("");
      }
    }
  }

  return (
    <div className="h-[85vh] w-full bg-white pt-10 px-4 rounded-lg mt-12">
      <div
        id="messages"
        ref={messageEl}
        class="h-[88%] w-full   flex flex-col space-y-4  px-4  overflow-y-auto scrollbar-thumb-blue scrollbar-thumb-rounded scrollbar-track-blue-lighter scrollbar-w-2 scrolling-touch"
      >
        {chats.map((d, i) => filter_fullchat(d))}
      </div>

      <div className="h-[12%]   flex flex-col">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          className={`w-10 h-10 p-0 self-center mt-0 cursor-pointer ${
            toggleFilterSection ? "" : "rotate-180"
          } `}
          fill="#949BA5"
          onClick={() => {
            setToggleFilterSection(!toggleFilterSection);
          }}
        >
          <path d="M17,9.17a1,1,0,0,0-1.41,0L12,12.71,8.46,9.17a1,1,0,0,0-1.41,0,1,1,0,0,0,0,1.42l4.24,4.24a1,1,0,0,0,1.42,0L17,10.59A1,1,0,0,0,17,9.17Z"></path>
        </svg>
        <div className="w-full  px-5 flex flex-row h-[85%]">
          <input
            onKeyDown={handleKeyDown}
            value={question}
            onChange={(e, d) => {
              setQuestion(e.target.value);
            }}
            placeholder="Type your query"
            className="rounded-l-[14px] sm:w-[95%] w-[85%] h-[60%] bg-[#F4F4F4] px-5"
          ></input>
          <div
            onClick={() => {
              addQuestion(question);
              setQuestion("");
            }}
            className="rounded-r-[14px] sm:w-[5%] w-[15%] h-[60%] bg-[#422AFB] flex items-center justify-center"
          >
            <img
              className="w-6 h-6 brightness-200"
              alt=""
              src={interfaceessentialsend1}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
